var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.$store.state.spinner)?_c('div',{staticClass:"loader"},[_c('div',{staticClass:"lds-ring"},[_c('div'),_c('div'),_c('div'),_c('div')])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }